import { cn } from "@akina/utils";
import * as RdCheckbox from "@radix-ui/react-checkbox";
import { Icon } from "./Icon/Icon";
import { Text } from "./Text";

export type CheckboxAttributes = RdCheckbox.CheckboxProps & {
  label?: string;
};
export type CheckedState = boolean | "indeterminate";

export const Checkbox = ({ onCheckedChange, className, checked = false, ...props }: CheckboxAttributes) => (
  <RdCheckbox.Root
    {...props}
    onCheckedChange={onCheckedChange}
    className={`hover:border-primary-100 data-[state=checked]:border-primary-100 data-[state=checked]:bg-primary-100 flex h-5 w-5 shrink-0 items-center justify-center rounded border border-gray-200 shadow-sm ${
      className ?? ""
    }`}
    checked={checked}>
    <RdCheckbox.Indicator>
      <Icon type="check" sizeClasses="h-3 w-3" className="text-white" key={props.key} />
    </RdCheckbox.Indicator>
  </RdCheckbox.Root>
);

type CheckboxWithLabelProps = {
  label: string;
  labelStyles?: string;
} & RdCheckbox.CheckboxProps

export const CheckboxWithLabel = ({ label, labelStyles, ...props }: CheckboxWithLabelProps) => (
  <div className="flex flex-row gap-2">
    <div className="shrink-0">
      <Checkbox {...props} />
    </div>
    <button onClick={() => props.onCheckedChange?.(!props.checked)}>
      <Text className={cn(labelStyles, "text-start whitespace-nowrap")}>{label}</Text>
    </button>
  </div>
);
